import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classnames from 'classnames';
import styled from 'styled-components';
import { track } from '../../../analytics/analytics';


const Button = styled.button`
  &.btn {
    border: 2px solid transparent;
  }

  &.btn:hover {
    background: rgba(157, 192, 255, 0.11);
    border-bottom-color: var(--blue-brdr);
  }

  &.btn:focus {
    box-shadow: 0 0 0 2px var(--blue-brdr);
    border-color: var(--blue-brdr);
  }
`;

class SearchFilterFieldset extends Component {
  state = {
    collapsed: true,
  };

  toggleCollapsed = () => {
    this.trackToggle(!this.state.collapsed);
    this.setState(({ collapsed }) => ({ collapsed: !collapsed }));
  };

  trackToggle = (collapsed) => {
    track(
      { category: 'SearchFilter', action: 'Toggle', label: this.props.title },
      { collapsed },
    );
  }

  render() {
    const {
      title,
      children,
      changed,
      changes,
    } = this.props;
    const { collapsed } = this.state;

    return (
      <div className="card mb-3">
        <div className="card-header card-collapse">
          <div className={classnames(['mb-0'], {
            'bg-soft-primary': changed,
          })}
          >
            <Button
              onClick={this.toggleCollapsed}
              type="button"
              className={classnames(['btn', 'btn-link', 'btn-block', 'd-flex', 'justify-content-between', 'card-btn', 'p-3'], {
                collapsed,
              })}
            >
              <span>
                <span className="text-dark">
                  {title}
                </span>
                {' '}
                {changes}
              </span>
              <span className="card-btn-arrow">
                <span className="fas fa-arrow-down small" />
              </span>
            </Button>
          </div>
        </div>
        <div
          className={classnames({
            collapse: true,
            show: !collapsed,
          })}
        >
          <div className="card-body">
            {children}
          </div>
        </div>
      </div>
    );
  }
}

SearchFilterFieldset.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
  changed: PropTypes.bool,
  changes: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

SearchFilterFieldset.defaultProps = {
  children: null,
  changed: false,
};

export default SearchFilterFieldset;
